import * as React from 'react';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import ScreenIcon from '@atlaskit/icon/glyph/screen';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { AutoScaledImage } from '@atlassian/help-center-common-component/auto-scaled-image';
import type { SearchProps } from '@atlassian/help-center-common-component/result-base';
import { SearchResultBase, emphasizeAndEscapeText } from '@atlassian/help-center-common-component/result-base';

interface Props extends SearchProps {
    id: number;
    searchTerm: string;
    name: string;
    logoUrl?: string;
}

const SearchResultPortal = ({ name, id, logoUrl, ...props }: Props) => {
    const screenIconProps: React.ComponentProps<typeof ScreenIcon> = isSearchEnhancementsMilestone1Enabled()
        ? {
              label: `${name} icon`,
              size: 'medium',
          }
        : {
              label: `${name} icon`,
              size: 'xlarge',
              primaryColor: token('color.icon', colors.N500),
          };

    return (
        <AnalyticsContext data={{ attributes: { portalId: id } }}>
            <SearchResultBase
                actionSubjectId="portal"
                elevated={isSearchEnhancementsMilestone1Enabled()}
                leftIcon={logoUrl ? <AutoScaledImage src={logoUrl} alt={name} /> : <ScreenIcon {...screenIconProps} />}
                titleHtml={emphasizeAndEscapeText(name, props.searchTerm)}
                to={`/portal/${id}`}
                {...props}
            />
        </AnalyticsContext>
    );
};

export default SearchResultPortal;
